/**
 * @generated SignedSource<<7801b8197d0a7dbca3c189bc2a46d21b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type aiTopicsGenerateTopicsFromHeadingMutation$variables = {
  heading: string;
  noteId: string;
  subheading: string;
};
export type aiTopicsGenerateTopicsFromHeadingMutation$data = {
  readonly generateTopicsFromHeading: {
    readonly topics: ReadonlyArray<string>;
  } | null;
};
export type aiTopicsGenerateTopicsFromHeadingMutation = {
  response: aiTopicsGenerateTopicsFromHeadingMutation$data;
  variables: aiTopicsGenerateTopicsFromHeadingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "heading"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "subheading"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "heading",
        "variableName": "heading"
      },
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      },
      {
        "kind": "Variable",
        "name": "subheading",
        "variableName": "subheading"
      }
    ],
    "concreteType": "GenerateTopicsFromHeading",
    "kind": "LinkedField",
    "name": "generateTopicsFromHeading",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "topics",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiTopicsGenerateTopicsFromHeadingMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "aiTopicsGenerateTopicsFromHeadingMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "6ac5755b6e4570420160883a7f6e1b28",
    "id": null,
    "metadata": {},
    "name": "aiTopicsGenerateTopicsFromHeadingMutation",
    "operationKind": "mutation",
    "text": "mutation aiTopicsGenerateTopicsFromHeadingMutation(\n  $heading: String!\n  $subheading: String!\n  $noteId: ID!\n) {\n  generateTopicsFromHeading(heading: $heading, subheading: $subheading, noteId: $noteId) {\n    topics\n  }\n}\n"
  }
};
})();

(node as any).hash = "a0577f8bfd1ddd7a07c95bebf4ab5192";

export default node;
